import $ from 'jquery';

const languageMenu =  ( function( document, window ) {
	const BODY = $( 'body' );
	const WIN_WIDTH = BODY.width();
	const _instance = {};
	const langToggle = $ ( '.js-menu-lang-item' );
	const submenu = $( '.js-submenu-lang' );
	const langArrow = $( '.js-toggle-submenu-lang' );
	_instance.init = function() {
		langToggle.on( 'click', function() {
			if ( 1199 > WIN_WIDTH ) {
				if ( submenu.hasClass( 'active' ) ) {
					submenu.removeClass( 'active' );
					submenu.slideUp();
					langArrow.removeClass( 'active' );
					langArrow.addClass( 'passive' );
				} else {
					submenu.addClass( 'active' );
					submenu.slideDown();
					langArrow.removeClass( 'passive' );
					langArrow.addClass( 'active' );
				}
			}
		});
		BODY.on( 'click', function( e ) {
			if ( 1199 > WIN_WIDTH ) {
				if ( ! $( e.target ).is( '.js-menu-lang-item span' ) && ! $( e.target ).is( '.js-toggle-submenu-lang' ) ) {
					submenu.hide();
					submenu.removeClass( 'active' );
					langArrow.removeClass( 'active' );
					langArrow.addClass( 'passive' );
				}
			}
		});
	};

	return _instance;

}( document, window ) );

export default  languageMenu;
